import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeWhile } from 'rxjs/operators';
import { NbAuthService } from '@nebular/auth';
import { UserService } from 'src/app/core/services/user.service';
import { UserModel } from 'src/app/core/models/user.model';

@Component({
  selector: 'dum-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent implements OnInit {
  init = false;
  isAuthenticated: boolean;
  alive: boolean = true;
  userLogged: UserModel;
  constructor( private authService: NbAuthService, private userService: UserService) {
    this.authService.isAuthenticated()
    .pipe(takeWhile(() => this.alive))
    .subscribe((result) => {
      if (result) {
        this.userService.findMe()
        .pipe(takeWhile(() => this.alive))
        .subscribe((user) => {
          this.userLogged = user;
          this.init = true;
          this.isAuthenticated = result;
        });
      } else {
        this.init = true;
      }
    });
  }

  ngOnInit(): void {
 }
}
